/* Refresh Shopify sections only after a successful cart operation. Never redirect to /cart. */
(() => {
  const shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  let pending;
  let openRequested = false;
  let deadline = 0;
  const timerKey = 'tuki-cart-deadline-v1';
  try { deadline = Number(sessionStorage.getItem(timerKey)) || 0; } catch (_) {}

  async function refresh(open = false) {
    openRequested = openRequested || open;
    if (pending) return pending;
    pending = (async () => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) throw new Error('No se encontró el carrito.');
      await customElements.whenDefined('cart-drawer');
      const response = await fetch(shopRoot + '?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('No pudimos actualizar el carrito.');
      const sections = await response.json();
      if (!sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error('No pudimos cargar el carrito.');
      const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      if (!parsed.querySelector('#CartDrawer')) throw new Error('Respuesta de carrito incompleta.');
      const shouldOpen = openRequested || drawer.classList.contains('active');
      if (shouldOpen && !drawer.classList.contains('active')) drawer.setActiveElement(document.activeElement);
      await drawer.renderContents({ sections }, shouldOpen);
      tick();
    })();
    try { return await pending; }
    finally { pending = null; openRequested = false; }
  }
  window.TukiCart = { refresh };

  document.addEventListener('click', event => {
    if (!event.target.closest('#cart-icon-bubble') || !document.querySelector('cart-drawer')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    refresh(true).catch(error => window.alert(error.message));
  }, true);

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-tuki-coupon]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('[name="discount"]');
    const code = input.value.trim();
    const status = form.querySelector('[data-tuki-coupon-status]');
    const button = form.querySelector('button');
    if (!code || button.disabled) return;
    button.disabled = true;
    status.textContent = 'Comprobando cupón…';
    try {
      // Preserve existing applicable codes when adding another one.
      const currentResponse = await fetch(shopRoot + 'cart.js', { cache: 'no-store' });
      if (!currentResponse.ok) throw new Error('No pudimos consultar el carrito.');
      const current = await currentResponse.json();
      const codes = (current.discount_codes || []).filter(item => item.applicable).map(item => item.code);
      if (!codes.some(item => item.toLowerCase() === code.toLowerCase())) codes.push(code);
      const response = await fetch(shopRoot + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'No pudimos aplicar el cupón.');
      const applied = (cart.discount_codes || []).some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable);
      await refresh(true);
      const nextForm = document.querySelector('[data-tuki-coupon]');
      if (nextForm) {
        nextForm.closest('details').open = true;
        nextForm.querySelector('[name="discount"]').value = code;
        nextForm.querySelector('[data-tuki-coupon-status]').textContent = applied
          ? 'Cupón aplicado. Los importes ya están actualizados.'
          : 'Este cupón no se puede aplicar a los productos o descuentos actuales.';
        nextForm.querySelector('[name="discount"]').focus();
      }
    } catch (error) { status.textContent = error.message || 'No pudimos aplicar el cupón. Intentá de nuevo.'; }
    finally { button.disabled = false; }
  });

  function tick() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('is-empty')) {
      deadline = 0;
      try { sessionStorage.removeItem(timerKey); } catch (_) {}
      return;
    }
    if (!drawer.classList.contains('active')) return;
    const output = drawer.querySelector('[data-tuki-countdown]');
    if (!output) return;
    if (!deadline) {
      deadline = Date.now() + 5 * 60 * 1000;
      try { sessionStorage.setItem(timerKey, String(deadline)); } catch (_) {}
    }
    const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    output.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    if (!seconds) output.closest('[data-tuki-cart-timer]').querySelector('small').textContent = 'Podés continuar tu compra; tu carrito sigue disponible.';
  }
  setInterval(tick, 1000);
})();
